import React, {useState, useEffect, useRef, FC} from 'react';
import * as fonts from '../../../../../util/fonts';
import './styles.scss';
import 'antd/dist/antd.css';
import {Pagination} from 'antd';
import Icon from '../../../../../components/icon';
import {Icons} from '../../../../../util/icons';
import AppSpinner from '../../../../../components/app-spinner';
import Row from '../../../../../components/layout/Row';
import {AppForm} from '../../../../../components/forms';
import * as Yup from 'yup';
import {compose} from 'redux';
import {connect} from 'react-redux';
import AppSelectInput from '../../../../../components/input/app-select-input/index';
import {
  formatEstimatedPrice,
  getCurrencyCode,
} from '../../../../../util/utility';
import {strings} from '../../../../../util/strings';
import {PriceTooltipAccordionIcon} from './PriceTooltipAccordionIcon';
import {Column} from '../../../../../components/layout';
import LocationsMap from './LocationsMap';
import {LatLngInterface} from './locationTypes';

interface PriceInterface {
  Value: string;
}
interface LocationProps {
  name: string;
  parish: string;
  address: string;
  postalCode: string;
  city: string;
  phone: number;
  id?: number;
  code: number;
  price: PriceInterface;
}

const validationSchema = Yup.object().shape({});

interface Stage2Props {
  results: LocationProps[];
  count: number;
  changePage(code: any, skip: any, order: any): any;
  nextStageClinicsNotGrouped(
    code: any,
    selectedClinicSection: any,
    fitler?: boolean
  ): any;
  codeToPagination: number;
  buStyles: any;
  currentPage: any;
  filterSelected?: any;
  setLocalHistory(value: any): void;
  localHistory: any;
  labelsMedicalNetwork: any;
  selectedBu: any;
  showPrice: boolean;
  shouldShowMap: boolean;
  precoEstimadoAtivo: boolean;
  precoEstimadoFuncAtiva: boolean;
  mobileMode: boolean;
}

enum Stage2Constants {
  RESULTS_PER_PAGE = 10,
}

const NewStage2: FC<Stage2Props> = ({
  results,
  count,
  nextStageClinicsNotGrouped,
  changePage,
  codeToPagination,
  buStyles,
  currentPage,
  filterSelected,
  localHistory,
  setLocalHistory,
  labelsMedicalNetwork,
  precoEstimadoFuncAtiva,

  showPrice,
  precoEstimadoAtivo,
  shouldShowMap,
  mobileMode,
}) => {
  const isPageMounted = useRef(false);
  const {RESULTS_PER_PAGE} = Stage2Constants;

  const [locations, setLocations] = useState<LocationProps[]>([]);
  const [locationsCount, setLocationsCount] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData]: any[] = useState([]);
  const [showTooltipInfo, setShowTooltipInfo] = useState(true);
  const [infoBoxPosition, setInfoBoxPosition] =
    useState<LatLngInterface | null>(null);
  const [showFullMap, setShowFullMap] = useState<boolean>(false);

  const filterOptions = [
    {
      value: 'Relevância',
      label: labelsMedicalNetwork?.medicalNetwork_filter_option_relevance,
    },
    {
      value: 'Ordem Alfabética',
      label: labelsMedicalNetwork?.medicalNetwork_filter_option_alphabetic,
    },
  ];

  //On mount data Request
  useEffect(() => {
    setLoading(true);
    setLocations(results);
    setLocationsCount(count);
    setPage(currentPage);
    isPageMounted.current = true;
    setLoading(false);
  }, []);

  // Set data per page
  useEffect(() => {
    if (isPageMounted.current) {
      setData(locations);
    }
  }, [page, isPageMounted.current]);

  const handleChangeInfoBoxPosition = (position: any) => {
    setInfoBoxPosition(position);
  };

  const onFilterChange = (value: any) => {
    changePage(codeToPagination, 1, value);
  };

  const prevNextArrowRender = (
    current: number,
    type: string,
    originalElement: any
  ) => {
    if (type === 'page') {
      return (
        <a
          rel="nofollow"
          className="pagination-number"
          style={{
            color: buStyles.primaryColor,
          }}>
          {current}
        </a>
      );
    }

    if (type === 'prev') {
      return (
        <button
          className="ant-pagination-item-link"
          style={{color: buStyles.primaryColor}}>
          <Icon
            name={Icons.CHEVRON_LEFT}
            width="50"
            height="30"
            changeViewbox={false}
            className="pagination-icons"
          />
        </button>
      );
    }
    if (type === 'next') {
      return (
        <button
          className="ant-pagination-item-link"
          style={{color: buStyles.primaryColor}}>
          <Icon
            name={Icons.CHEVRON_RIGHT}
            width="50"
            height="30"
            changeViewbox={false}
            className="pagination-icons"
          />
        </button>
      );
    }

    return originalElement;
  };

  const handleOnClickLocation = (location: any, data: any) => {
    // mobileMode
    //   ? handleOnClickLocationDetails(location.code)
    //   : handleChangeInfoBoxPosition({
    //       lat: location.latitude,
    //       lng: location.longitude,
    //     });
    handleOnClickLocationDetails(location.code);
  };

  const handleOnClickLocationDetails = (code: any) => {
    setLocalHistory([...localHistory, 'stage2Clinics']);
    nextStageClinicsNotGrouped(code, data, true);
  };

  const expandMap = () => {
    setShowFullMap(!showFullMap);
  };

  const renderLocations = () => {
    return (
      <div className="location-list">
        <Row className="estimated-price-row">
          <AppForm
            initialValues={{}}
            label={filterSelected}
            onSubmit={() => {}}
            validationSchema={validationSchema}>
            <div>
              <AppSelectInput
                className="filter-drop-down"
                value={filterSelected}
                options={filterOptions}
                onChange={(value) => onFilterChange(value)}
              />
            </div>
          </AppForm>

          {precoEstimadoAtivo && showPrice && (
            <div className="price-tooltip-title-div">
              <div className="price-tooltip-title">
                {labelsMedicalNetwork?.medicalNetwork_price_tooltip_title}
              </div>
              <PriceTooltipAccordionIcon
                showTooltipInfo={showTooltipInfo}
                setShowTooltipInfo={setShowTooltipInfo}
                color={buStyles.primaryColor}
              />
            </div>
          )}
        </Row>
        <Row>
          {showTooltipInfo && precoEstimadoAtivo && showPrice && (
            <Row className="price-tooltip-description-div">
              <div className="price-tooltip-description">
                {labelsMedicalNetwork?.medicalNetwork_price_tooltip_description}
              </div>
            </Row>
          )}
        </Row>

        {data.map((location: LocationProps) => (
          <div>
            <Row className="location-card-top">
              <Column className="location-title-column">
                <a
                  className="location-title"
                  style={{color: buStyles.primaryColor}}
                  onClick={() => handleOnClickLocation(location, data)}>
                  {location.name}
                </a>
              </Column>
              {precoEstimadoFuncAtiva && showPrice && (
                <Column className="estimated-price-column">
                  <div onClick={() => handleOnClickLocation(location, data)}>
                    <span
                      className={
                        location.price
                          ? 'estimated-price'
                          : 'no-price-estimated'
                      }
                      style={{...fonts.M, ...fonts.Bold}}>
                      {location.price
                        ? `${formatEstimatedPrice(
                            location.price.Value
                          )} ${getCurrencyCode(undefined, "rede")}`
                        : `-`}
                    </span>
                  </div>
                </Column>
              )}
            </Row>

            <p className="location-address">
              {location.address}, {location.parish} <br /> {location.postalCode}
              , {location.city} <br /> {location.phone}
            </p>
            <div className="bottom-line"></div>
          </div>
        ))}
      </div>
    );
  };

  const onPaginationChange = (page: any) => {
    setPage(page);
    if (locationsCount > 10) {
      changePage(codeToPagination, page, filterSelected);
    }
  };

  const shouldHideLeftPanel = () => {
    return mobileMode ? shouldShowMap : showFullMap;
  };

  const shouldHideRightPanel = () => {
    return mobileMode ? !shouldShowMap : false;
  };

  return (
    <div className="main-container">
      {!isLoading ? (
        <React.Fragment>
          <div className="location-container">
            {/* {mobileMode && !showFullMap} */}

            {!shouldHideLeftPanel() && (
              <div id="location-panel-left" className="location-panel-left">
                {renderLocations()}
              </div>
            )}
            {!shouldHideRightPanel() && (
              <div
                id="location-panel-right"
                className={`location-panel-right${
                  showFullMap ? '-full-width' : ''
                }`}>
                <LocationsMap
                  precoEstimadoFuncAtiva={precoEstimadoFuncAtiva}
                  buStyles={buStyles}
                  showFullMap={showFullMap}
                  showPrice={showPrice}
                  expandMap={expandMap}
                  infoBoxPosition={infoBoxPosition}
                  handleChangeInfoBoxPosition={handleChangeInfoBoxPosition}
                  handleOnClickLocationDetails={handleOnClickLocationDetails}
                  locations={data}
                />
              </div>
            )}
          </div>
          {!!(!showFullMap && !shouldShowMap) && (
            <>
              <Pagination
                onChange={(page) => onPaginationChange(page)}
                current={page}
                total={locationsCount}
                pageSize={RESULTS_PER_PAGE}
                itemRender={prevNextArrowRender}
                responsive
                className="location-list-pagination"
              />
              <p className="results-count-text">
                {Math.floor(locationsCount - 10 * page) < 0
                  ? locationsCount - (page - 1) * 10
                  : 10}{' '}
                {labelsMedicalNetwork.medicalNetwork_results_from}{' '}
                {locationsCount} {labelsMedicalNetwork.medicalNetwork_results}
              </p>
            </>
          )}
        </React.Fragment>
      ) : (
        <div className="stage-two-spinner">
          <AppSpinner className="spinner-style" />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({
  globalStyles,
  strings,
  selectedBu,
}: any) => ({
  labelsMedicalNetwork: strings.value.pt.rede,
  buStyles: globalStyles.value,
  selectedBu: selectedBu.value,
});

export default compose(connect(mapStateToProps)(NewStage2));
